export default {
  name: 'vx-campaign-takes-action-slides',
  data() {
    return {

    };
  },
  props: {
    slide: {
      type: Array,
    },
    currentIndex: {
      type: Number,
    },
    currentSlider: {
      type: Object,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/campaigns/vx-campaign-brawny-takes-action/vx-campaign-brawny-takes-action-slides/vx-campaign-brawny-takes-action-slides.js